<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="table-block">
  <div class="recordRow">
    <div class="recordLabel">Address1</div>
    <div id="addressLine1" class="recordValue">
      {{ merchant.merchantAddress?.address1! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Address2</div>
    <div id="addressLine2" class="recordValue">
      {{ merchant.merchantAddress?.address2! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">City</div>
    <div id="city" class="recordValue">
      {{ merchant.merchantAddress?.city! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">State</div>
    <div id="state" class="recordValue">
      {{ merchant.merchantAddress?.state! | stateAbrrToName }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Zip</div>
    <div id="zip" class="recordValue">
      {{ merchant.merchantAddress?.zip! }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">Country</div>
    <div id="country" class="recordValue">
      {{ merchant.merchantAddress?.country! }}
    </div>
  </div>
</div>
<div *ngIf="merchant.remitToAddress">
  <fieldset>
    <legend class="borderDivide">
      <div class="col-md-12 removePadding borderSeparation">
        Remit-to Address
      </div>
    </legend>
    <div class="table-block">
      <div class="mt-3">
        <div class="recordRow">
          <div class="recordLabel">Name</div>
          <div id="remitMerchantName" class="recordValue">
            {{ merchant.remitToAddress.merchantName! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">Address1</div>
          <div id="merchant.remitToAddressLine1" class="recordValue">
            {{ merchant.remitToAddress.address1! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">Address2</div>
          <div id="merchant.remitToAddressLine2" class="recordValue">
            {{ merchant.remitToAddress.address2! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">City</div>
          <div id="remitCity" class="recordValue">
            {{ merchant.remitToAddress.city! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">State</div>
          <div id="remitState" class="recordValue">
            {{ merchant.remitToAddress.state! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">Zip</div>
          <div id="remitZip" class="recordValue">
            {{ merchant.remitToAddress.zip! }}
          </div>
        </div>

        <div class="recordRow">
          <div class="recordLabel">Country</div>
          <div id="remitCountry" class="recordValue">
            {{ merchant.remitToAddress.country! }}
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</div>
